module.exports = __webpack_public_path__ + "assets/de15363f059401775965f0b625d6dfa7.svg";